export default __webpack_public_path__ + "static/media/icon.6e484c39.ico";